<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="车费名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入车费名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加车费</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="name" align="center" label="名称" width="150px">
          </el-table-column>
          <el-table-column prop="startingPrice" align="center" label="起步价">
            <template slot-scope="scope">
              <div style="color:#409eff">{{scope.row.startingPrice}}元</div>
            </template>
          </el-table-column>
          <el-table-column prop="kilometerPrice" align="center" label="每公里价格">
            <template slot-scope="scope">
              <div>{{scope.row.kilometerPrice}}元</div>
            </template>
          </el-table-column>
          <el-table-column prop="minNum" align="center" label="免费公里数">
            <template slot-scope="scope">
              <div style="color:red">{{scope.row.minNum}}Km</div>
            </template>
          </el-table-column>
          <el-table-column prop="exceedNum" align="center" label="公里数"></el-table-column>
          <el-table-column prop="peakStart" align="center" label="高峰期开始时间"></el-table-column>
          <el-table-column prop="peakEnd" align="center" label="高峰期结束时间"></el-table-column>
          <el-table-column prop="peakStartingPrice" align="center" label="高峰期起步价"></el-table-column>
          <el-table-column prop="peakStartingPrice" align="center" label="高峰期每公里价格"></el-table-column>
          <el-table-column prop="peakExceedNum" align="center" label="高峰期起步公里数"></el-table-column>

          <el-table-column prop="isFree" label="是否免费" align="center" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.isFree==1">否</div>
              <div style="color:red" v-else>是</div>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑车费</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small">删除车费</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import fareAPI from "@/api/fare.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        name: ""
      },
      isFree: "", //车费是否显示
      itemmodel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/setting/fare_setting/add");
    },

    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      fareAPI
        .fareList(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      this.itemmodel = row;
      // this.$router.push({
      //   path: "/setting/fare_setting/edit",
      //   params: { row }
      // });
      this.$router.push({
        path: "/setting/fare_setting/edit",
        query: {
          params: row,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          fareAPI
            .fareDel({
              id: row.id
            })
            .then(data => {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getData();
            });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/fare_setting/index.vue